import { useTranslation } from "@firecms/core";
import { useCallback, useMemo } from "react";
import { normalizeFireCMSLocale } from "./adminLocales";
import { getAdminT, type AdminTranslateFn } from "./getAdminT";
import type { Locale } from "../localization/constants";

export function useAdminTranslation(): {
  t: AdminTranslateFn;
  locale: Locale;
} {
  const { i18n } = useTranslation();
  const locale = normalizeFireCMSLocale(i18n.language) as Locale;

  const t = useCallback(
    (key: string, vars?: Record<string, string | number>) =>
      getAdminT(locale)(key, vars),
    [locale]
  );

  return useMemo(() => ({ t, locale }), [t, locale]);
}
